import { Box, Typography } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'
import styled from 'styled-components'
import { irem } from '../../utils'

export const StyledDisclaimerWrapper = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
`

export const StyleDisclaimerTitleContainer = styled.div`
  padding-left: ${props => props.theme.typography.pxToRem(18)};
  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: ${props => props.theme.typography.pxToRem(33)};
  }
`

export const StyledDisclaimerTitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  font-weight: 700;
  letter-spacing: ${props => props.theme.typography.pxToRem(2.1)};
  text-align: center;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(14)};
  }
`

export const StyledDisclaimerTextBlockContainer = styled.div`
  background-color: ${alpha('#f2f2f2', 1)};
  padding: ${props => props.theme.typography.pxToRem(35)} ${props => props.theme.typography.pxToRem(30)};
  
  &:last-child {
    border-bottom-left-radius: ${irem(12)};
    border-bottom-right-radius: ${irem(12)};
  }
    
  ${StyleDisclaimerTitleContainer} + &, &:first-child {
    border-top-left-radius: ${irem(12)};
    border-top-right-radius: ${irem(12)};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.typography.pxToRem(25)} ${props => props.theme.typography.pxToRem(46)};
  }
`

export const StyledDisclaimerTextBlock = styled(Box)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  line-height: ${props => props.theme.typography.pxToRem(25)};
  color: black;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(16)};
    line-height: 1.5;

    > br {
      line-height: 1.5;
    }

    > a {
      word-break: break-all;
    }
  }

  > * {
    margin: 0;
    font-size: ${props => props.theme.typography.pxToRem(15)};

    ${props => props.theme.breakpoints.up('sm')} {
      font-size: ${props => props.theme.typography.pxToRem(16)};
    }
  }
`